import { useState } from "react";
import Popup from "reactjs-popup";
import ChipWithRef from "../../../../Common/components/Chip/ChipWithRef";
import RangeSlider from "../../../../Common/components/Inputs/RangeSlider/RangeSlider";
import { CiFilter } from "react-icons/ci";
import t from "../../../../Common/utils/translation/translator";

const FiltersPopup = ({
  column,
  chipLabel,
  bundles,
  filters,
  nominalTorqueFilterDefaultValues,
  inertiaRatioFilterDefaultValues,
  onApply,
  ...props
}) => {
  const [nominalTorqueMinValue, setNominalTorqueMinValue] = useState(nominalTorqueFilterDefaultValues.min);
  const [nominalTorqueMaxValue, setNominalTorqueMaxValue] = useState(nominalTorqueFilterDefaultValues.max);

  const [intertiaRatioMinValue, setIntertiaRatioMinValue] = useState(inertiaRatioFilterDefaultValues.min);
  const [intertiaRatioMaxValue, setIntertiaRatioMaxValue] = useState(inertiaRatioFilterDefaultValues.max);

  const handleNominalTorqueValueChange = (newMin, newMax) => {
    setNominalTorqueMinValue(newMin);
    setNominalTorqueMaxValue(newMax);
  };

  const handleIntertiaRatioValueChange = (newMin, newMax) => {
    setIntertiaRatioMinValue(newMin);
    setIntertiaRatioMaxValue(newMax);
  };

  const nominalTorqueSliderMinMark = Number(parseFloat(filters?.applicationDataFilter?.nominalTorque).toFixed(2));
  const nominalTorqueSliderMaxMark = Math.max(
    ...bundles.map((bundle) => Number(bundle.nominalTorque.toFixed(2))),
    Number((parseFloat(filters?.applicationDataFilter?.nominalTorque || 1) * 3).toFixed(2))
  );

  const nominalTorqueSliderStep = (nominalTorqueSliderMaxMark - nominalTorqueSliderMinMark) / 4;
  const nominalTorqueSliderMarks = Array.from({ length: 5 }, (_, k) => ({
    value: Number((nominalTorqueSliderMinMark + k * nominalTorqueSliderStep).toFixed(2)),
    label: Number((nominalTorqueSliderMinMark + k * nominalTorqueSliderStep).toFixed(2)) + "Nm"
  }));

  return (
    <Popup
      trigger={<ChipWithRef data-testid={`${column}-filter-chip`} label={chipLabel} icon={<CiFilter />} />}
      position="bottom center"
      nested
      contentStyle={{
        background: "white",
        width: "544px",
        padding: "2rem",
        borderRadius: "12px",
        boxShadow: "0px 8px 40px 0px rgba(0, 0, 0, 0.25)"
      }}
      overlayStyle={{ background: "transparent" }}
      arrow={false}
      className="FiltersPopup"
      onClose={() => {
        handleNominalTorqueValueChange(nominalTorqueFilterDefaultValues.min, nominalTorqueFilterDefaultValues.max);
        handleIntertiaRatioValueChange(inertiaRatioFilterDefaultValues.min, inertiaRatioFilterDefaultValues.max);
      }}
      {...props}
    >
      <div className="flex flex-col gap-8">
        <RangeSlider
          data-testid={`${column}-nominal-torque-range-slider`}
          title={t("msizer.ui.popup.choose_nominal_torque")}
          minValue={nominalTorqueMinValue}
          maxValue={nominalTorqueMaxValue}
          onValueChange={handleNominalTorqueValueChange}
          step={0.01}
          minPossible={nominalTorqueSliderMinMark}
          maxPossible={nominalTorqueSliderMaxMark}
          marks={nominalTorqueSliderMarks}
        />
        <RangeSlider
          data-testid={`${column}-inertia-range-slider`}
          title={t("msizer.ui.popup.choose_inertia_range")}
          minValue={intertiaRatioMinValue}
          maxValue={intertiaRatioMaxValue}
          onValueChange={handleIntertiaRatioValueChange}
          step={0.1}
          minPossible={0}
          maxPossible={15}
          marks={[
            { value: 0, label: "0" },
            { value: 3, label: "3" },
            { value: 6, label: "6" },
            { value: 9, label: "9" },
            { value: 12, label: "12" },
            { value: 15, label: "15" }
          ]}
        />
        <div className="flex flex-col items-center gap-2">
          <p>
            {t("msizer.ui.popup.show_x_items_of_y", {
              nb_items: bundles.filter(
                (bundle) =>
                  Number(bundle?.nominalTorque.toFixed(2)) >= nominalTorqueMinValue &&
                  Number(bundle?.nominalTorque.toFixed(2)) <= nominalTorqueMaxValue &&
                  Math.round(filters?.applicationDataFilter?.loadInertia / Number(bundle?.inertia.toFixed(2))) >=
                    intertiaRatioMinValue &&
                  Math.round(filters?.applicationDataFilter?.loadInertia / Number(bundle?.inertia.toFixed(2))) <=
                    intertiaRatioMaxValue
              ).length,
              nb_total_items: bundles.length
            })}
          </p>
          <qds-button
            size="large"
            importance="emphasized"
            {...(bundles.filter(
              (bundle) =>
                Number(bundle?.nominalTorque.toFixed(2)) >= nominalTorqueMinValue &&
                Number(bundle?.nominalTorque.toFixed(2)) <= nominalTorqueMaxValue &&
                Math.round(filters?.applicationDataFilter?.loadInertia / Number(bundle?.inertia.toFixed(2))) >=
                  intertiaRatioMinValue &&
                Math.round(filters?.applicationDataFilter?.loadInertia / Number(bundle?.inertia.toFixed(2))) <=
                  intertiaRatioMaxValue
            ).length === 0
              ? { disabled: "" }
              : {})}
            text={t("msizer.ui.popup.button.apply")}
            onClick={() => {
              onApply(nominalTorqueMinValue, nominalTorqueMaxValue, intertiaRatioMinValue, intertiaRatioMaxValue);
            }}
          ></qds-button>
        </div>
      </div>
    </Popup>
  );
};

export default FiltersPopup;
